import { LocalStorageUtils } from '@shared/utils';
import { useCallback, useMemo, useState } from 'react';

export enum ViewEnum {
  Grid = 'grid',
  List = 'list',
}
export type PageType = 'accounts' | 'cards' | 'users';

interface UseViewProps {
  page?: PageType;
}

export const useView = (props: UseViewProps = {}) => {
  const [view, setView] = useState<ViewEnum>(() => {
    if (props.page) return LocalStorageUtils.getView()[props.page] || ViewEnum.Grid;
    return ViewEnum.Grid;
  });

  const changeViewHandler = useCallback(
    (view: ViewEnum) => {
      setView(view);
      if (props.page) LocalStorageUtils.setView({ [props.page]: view });
    },
    [props.page],
  );

  return useMemo(
    () => ({
      view,
      isGrid: view === ViewEnum.Grid,
      isList: view === ViewEnum.List,
      onChangeView: changeViewHandler,
    }),
    [view, changeViewHandler],
  );
};
